



















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { getExpNoPage } from '@/api/user/user'
import Exp from '@/components/exp.vue'

@Component({
  components: {
    Exp
  }
})
export default class List extends Vue {
  @Prop() private data!: object[]
  @Prop() private total!: any
  @Prop() private currentPage!: string
  // 获取登录信息
  get userInfo() {
    return this.$store.state.userInfo
  }
  private defaultImg: string = process.env.VUE_APP_IMG_TASK_DEFAULT
  // 跳转详情页
  private goDetail(item) {
    let currentPage=''
    switch (item.type) {
      case 0:
        currentPage='crowd'
        break;
      case 1:
        currentPage='team'
        break;
      case 2:
        currentPage='train'
        break;
      case 3:
        currentPage='authUser'
        break;
      case 5:
        currentPage='pkgTask'
        break;
    }
    console.log(currentPage)
    this.$router.push({
      name: 'detail',
      params: { page: currentPage, id: item.id }
    })
  }
}
